import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import DescriptionTable from '../RoundSpecialsMatchTimeline/DescriptionTable';
import OddsRow from './OddsRow';
import { PAGES } from '../../constants';
import { getLeaguesMemoized } from '../../selectors/common';
import { aGetRoundSpecialDetailsAction, aSetSelectedOddsHistoryRoundSpecialAction } from '../../reducers/roundSpecials';
import { getRoundSpecialDetails, getRoundSpecialOddsHistoryTemplate } from '../../selectors/roundSpecials';

const RoundSpecialsOddsHistoryStep1 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const allMarkets = useSelector(getRoundSpecialOddsHistoryTemplate);
  const details = useSelector(getRoundSpecialDetails);
  const leagues = useSelector(getLeaguesMemoized);
  const selectedLeague = leagues.find((league) => league.id === details?.leagueId);

  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedMarkets, setSelectedMarkets] = useState([]);

  const chunkedMarkets = allMarkets.reduce((acc, _, index) => {
    if (index % 5 === 0) {
      acc.push(allMarkets.slice(index, index + 5));
    }
    return acc;
  }, []);

  function toggleAllChecked() {
    if (isAllChecked) {
      setSelectedMarkets([]);
      setIsAllChecked(false);
      dispatch(aSetSelectedOddsHistoryRoundSpecialAction({ marketIds: []}));
    } else {
      const allMarketIds = allMarkets.map((market) => market.id);
      setSelectedMarkets(allMarketIds);
      setIsAllChecked(true);
      dispatch(aSetSelectedOddsHistoryRoundSpecialAction({ marketIds: allMarketIds}));
    }
  }

  function handleOddsClick(marketId) {
    const isChecked = selectedMarkets.includes(marketId);
    const newSelectedMarkets = isChecked ? selectedMarkets.filter((id) => id !== marketId) : [...selectedMarkets, marketId];
    setSelectedMarkets(newSelectedMarkets);
    dispatch(aSetSelectedOddsHistoryRoundSpecialAction({ marketIds: newSelectedMarkets}));
  }

  useEffect(function loadRoundSpecialMatchDetail() {
    if (params?.id) {
      dispatch(aGetRoundSpecialDetailsAction({ id: params.id }));
    }
  }, [dispatch, params?.id]);

  return (
    (
      <>
        <DescriptionTable roundId={details?.roundId} publicRoundId={details?.roundPublicId} leagueName={selectedLeague?.name} seasonId={details?.seasonId} />
        <div className="odds-type m-t-30">
          <div className="odds-type__head">
            <div className="odds-type__head-txt">Odds types</div>
            <div className="odds-type__head-check">
              <label className="checkbox">
                <input id="checkbox__AllChecked" type="checkbox" className="checked--all" onChange={toggleAllChecked} checked={isAllChecked} />
                <div className="checkbox__icon m-r-20" />
                <span className="checkbox__label">Check/Uncheck All</span>
              </label>
            </div>
          </div>
          <div className="odds-type__content">
            {chunkedMarkets.map((row, index) => (
              <OddsRow
                key={index}
                row={row}
                selectedMarkets={selectedMarkets}
                onHandleOddsClick={handleOddsClick}
              />
            ))}
          </div>
          <div className="odds-type__btn text-right">
            <div
              className="btn btn-secondary"
              onClick={() => navigate(-1)}
            >
            Cancel
            </div>
            <Link
              to={`${PAGES.ROUND_SPECIALS_ODDS_HISTORY_STEP_2}/${params.id}`}
              className={`btn btn-primary m-l-10 ${selectedMarkets.length === 0 ? 'disabled' : ''}`}
            >
            Continue
            </Link>
          </div>                  
        </div>
      
      </>
    )
  );
};

export default RoundSpecialsOddsHistoryStep1;